import * as React from 'react'

import { XIcon } from 'lucide-react'

import { Button } from '~/client/src/shared/components/Button/Button'
import Localization from '~/client/src/shared/localization/LocalizationManager'

import './PurpleConfirm.scss'

interface IProps {
  title: string
  actionTitle: string
  isShown: boolean
  className?: string
  testId?: string
  onHide(): void
  onApply(): void
}

export default class PurpleConfirm extends React.Component<IProps> {
  public render() {
    const {
      title,
      actionTitle,
      isShown,
      className,
      children,
      onHide,
      onApply,
      testId,
    } = this.props

    return (
      isShown && (
        <div
          className={`purple-confirm ${className || ''}`}
          data-testid={testId}
        >
          <div className="purple-confirm-header">{title}</div>
          <Button
            variant="ghost"
            size="icon-sm"
            className="tw:absolute tw:top-1 tw:right-1 tw:text-primary-foreground"
            aria-label={Localization.translator.close}
            onClick={onHide}
          >
            <XIcon />
          </Button>
          <div className="purple-confirm-body">{children}</div>
          <div className="row x-center no-flex-children">
            <Button variant="primary-outline" onClick={onApply}>
              {actionTitle}
            </Button>
          </div>
        </div>
      )
    )
  }
}
